import "../../assets/style/main.css";
import "./style.scss"
import { useEffect, useRef, useState } from "react";
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from "../../utils/Encryption";
import moment from "moment";
import { Base_API } from "../../_actions/matcher";
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import ARROW_DOWN_ICON from '../../assets/images/icons/arrow-b.png'
import Breadcrumb_Step from "../../components/Breadcrumb_Step";
import { getJWTbyPatientID } from "../../_actions/sso.authen";
import { NhealthAction } from "../../_actions/action.api";
import { ALERT } from "../../components/CustomAlert";

export default function KYC_Step_1() {
    let onceMount = useRef(true);
    const DOB_DAY = useRef(null);
    const DOB_MONTH = useRef(null);
    const DOB_YEAR = useRef(null);
    const INPUT_CARD_ID = useRef(null);
    const INPUT_PASSPORT_ID = useRef(null);
    const INPUT_PHONE_NUMBER = useRef(null); 
    const INPUT_EMAIL = useRef(null);
    const INPUT_FIRSTNAME_TH = useRef(null);
    const INPUT_LASTNAME_TH = useRef(null);
    const INPUT_FIRSTNAME_EN = useRef(null);
    const INPUT_LASTNAME_EN = useRef(null);
    const RADIO_FEMALE = useRef(null);
    const RADIO_MALE = useRef(null);
    const RADIO_SINGLE = useRef(null);
    const RADIO_MARRIED = useRef(null);

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    const [typeRegis, setTypeRegis] = useState(true); // true = idcard | false = passport
    const [ddMonth, setDDmonth] = useState([
        {
            id: 1,
            nameTH: "มกราคม",
            nameEN: "Jan",
        },
        {
            id: 2,
            nameTH: "กุมภาพันธ์",
            nameEN: "Feb",
        },
        {
            id: 3,
            nameTH: "มีนาคม",
            nameEN: "Mar",
        },
        {
            id: 4,
            nameTH: "เมษายน",
            nameEN: "Apr",
        },
        {
            id: 5,
            nameTH: "พฤษภาคม",
            nameEN: "May",
        },
        {
            id: 6,
            nameTH: "มิถุนายน",
            nameEN: "Jun",
        },
        {
            id: 7,
            nameTH: "กรกฎาคม",
            nameEN: "Jul",
        },
        {
            id: 8,
            nameTH: "สิงหาคม",
            nameEN: "Aug",
        },
        {
            id: 9,
            nameTH: "กันยายน",
            nameEN: "Sept",
        },
        {
            id: 10,
            nameTH: "ตุลาคม",
            nameEN: "Oct",
        },
        {
            id: 11,
            nameTH: "พฤศจิกายน",
            nameEN: "Nov",
        },
        {
            id: 12,
            nameTH: "ธันวาคม",
            nameEN: "Dec",
        },
    ]);
    const [ddDays, setDDdays] = useState([]);
    const [ddYears, setDDyears] = useState([]);
    const [ddGender, setDDgender] = useState([
        {
            id: 1,
            nameTH: "ชาย",
            nameEN: "male",
        },
        {
            id: 2,
            nameTH: "หญิง",
            nameEN: "female",
        },
        // { id: 3,
        //     nameTH: "อื่นๆ",
        //     nameEN: "other",
        // },
    ]);
    const [formData, setFormData] = useState({
        citizenid: "",
        passport: "",
        back_idcard: "", 
        firstname_th: "",
        lastname_th: "",
        firstname_en: "",
        lastname_en: "",
        dob: "",
        gender: "",
        marry: "",
        phone: "",
        email: "",
    });
    const [lockInputCardID, setLockInputCardID] = useState(false);
    // const [isOpen, setIsOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState({
        citizenid: "",
        passport: "",
        back_idcard: "",
        first_name_th: "",
        last_name_th: "",
        first_name_en: "",
        last_name_en: "",
        gender: "",
        marry: "",
        tel: "",
        email: "",
    });
    const [isForeign, setIsForeign] = useState(false);


    const pageInit = async () => {
        await dropdownInit();
        let patientData = await patientInit();
        await inputDataInit(patientData);
        checkCurrentURL();
        // await signinPhone();
        // await signinEmail();

        // let jwtToken = await getJWTToken();
        // await getProfile(jwtToken);
        // await EditProfile(jwtToken);

        // let OTP = await sendOTPSMS();
        // await sendOTPEmail();
        // await verifyOTP(); 

        // await getUserSignin();

        // await registration();

        isPageLoading(false);
    };



    const inputDataInit = (patientData) => {
        return new Promise(async resolve => {
            let invalidCitizenID = localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_CITIZENID_INVALID);
            if(!!invalidCitizenID)
            {
                // Input Init
                let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;             
                console.log('updateKycPayload: ', updateKycPayload);
                
                let back_idcard = formatBackCardID(updateKycPayload.back_idcard);
                let firstname_th = updateKycPayload.first_name_th;
                let lastname_th = updateKycPayload.last_name_th;
                let firstname_en = updateKycPayload.first_name_en;
                let lastname_en = updateKycPayload.last_name_en;
                let gender = updateKycPayload.gender;
                let marry = updateKycPayload.marry;
                let phone = formatThaiPhoneNumber(updateKycPayload.phone_number);
                let email = updateKycPayload.email;
                let citizenid = patientData.data.identity_id_view
                setFormData({
                    ...formData,
                    citizenid,
                    back_idcard,
                    firstname_th,
                    lastname_th,
                    firstname_en,
                    lastname_en,
                    gender,
                    marry,
                    phone,
                    email
                })

                let dob_split = String(updateKycPayload.dob).split('-');
                let monthNumber = parseInt(dob_split[1]);
                DOB_DAY.current.value = dob_split[0];
                DOB_MONTH.current.value = monthNumber;
                DOB_YEAR.current.value = dob_split[2];
                $('select#select-day').val(String(dob_split[0]));
                $('select#select-month').val(String(monthNumber));
                $('select#select-year').val(String(dob_split[2]));

                $(`input[value="${gender}"]`).prop('checked', true);
                $(`input[value="${marry}"]`).prop('checked', true);

                INPUT_PHONE_NUMBER.current.value = phone;

                // Focus citizenID Input
                let type_regis = DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS));
                if(type_regis === 'idcard')
                {
                    $('input[name="card_id"]').focus();
                }else
                {
                    $('input[name="passport_id"]').focus();
                }

                resolve();
            }else
            {
                await initPatientInput(patientData);
                resolve();
            }
        })
    }

    const initPatientInput = (res) => {
        return new Promise(async resolve => {
            let patientData = res.data;
    
            let newForm = {}
    
            let dob = String(patientData.birthday).split('-');
            let day = Number(dob[2])
            let month = Number(dob[1]);
            let year = Number(dob[0])
            console.log('day: ', day);
            console.log('month: ', month);
            console.log('year: ', year);
            let firstNameTH = patientData.name_th;
            let lastNameTH = patientData.surname_th;
            let firstNameEN = patientData.name_en;
            let lastNameEN = patientData.surname_en;
            let gender = String(patientData.gender).toLowerCase();
            let marry = String(patientData.marry).toLowerCase();
            if(!!gender)
            {
                if(gender === 'f')
                {
                    $(RADIO_FEMALE.current).prop('checked', true);               
                    newForm["gender"] = "F";
                }else
                {
                    $(RADIO_MALE.current).prop('checked', true);
                    newForm["gender"] = "M";
                }
            }
            if(!!marry)
            {
                if(marry === 's')
                    {
                    newForm["marry"] = 'S';
                    $(RADIO_SINGLE.current).click();               
                }else
                {
                    newForm["marry"] = 'M';
                    $(RADIO_MARRIED.current).click();               
                }
            }
            $(DOB_YEAR.current).prop('value', year);
            $(DOB_MONTH.current).prop('value', month);
            $(DOB_DAY.current).prop('value', day);
    
            setIsForeign(patientData.isForeign)
            newForm["citizenid"] = patientData.identity_id_view
            newForm["passport"] = patientData.identity_id_view
            newForm["firstname_th"] = firstNameTH
            newForm["lastname_th"] = lastNameTH
            newForm["firstname_en"] = firstNameEN
            newForm["lastname_en"] = lastNameEN
            newForm["phone"] = patientData.phonenumber
            newForm["email"] = patientData.email
    
            setFormData({...formData, ...newForm})
            resolve();
        })
    }

    const patientInit = () => {
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null; 
            let jwtData = await getJWTbyPatientID(patientData.data.patientid);
            
            let headers = {
                token: jwtData.token,
                userRef: patientData.data.patientid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let rawReq = {
                "refEXP": patientData.refEXP,
                "isType": patientData.isType,
                "refAction": patientData.refAction,
                "refType": patientData.refType,
            }
            let reqData = {
                data: EncryptedOBJ(rawReq)
            }

            console.log('raw get patient req: ', rawReq);

            NhealthAction.GetPatientProfile(reqData, headers)
            .then(res => {
                console.log('get patient: ', res);
                if(res.IsSuccess)
                {
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA, EncryptedOBJ(res))
                    resolve(res);
                }
            })
        })
    }

    const checkCurrentURL = () => {
        let pathname = location.pathname;
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
    }

    const idcardInfoInit = () => {
        let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
        let dataEnc = localStorage.getItem(dataEncName);
        console.log('Data Enc: ', dataEnc);
        if(!!dataEnc)
        {
            let dataDecrypted = DecryptedOBJ(dataEnc);
            let dob = String(dataDecrypted.dob).split('-');
            let day = Number(dob[0])
            let month = Number(dob[1]);
            let year = Number(dob[2])
            let currentAge = calculateAge(String(day), String(month), String(year));
            let formatCardID = formatNationalID(String(dataDecrypted.card_id))
            let fullNameTH = String(dataDecrypted.full_name);
            let lastIndexFullNameTH = fullNameTH.lastIndexOf(' ');
            let firstNameTH = fullNameTH.substring(0, lastIndexFullNameTH);
            let lastNameTH = fullNameTH.substring(lastIndexFullNameTH + 1);
            let fullNameEN = String(dataDecrypted.full_name_en);
            let lastIndexFullNameEN = fullNameEN.lastIndexOf(' ');
            let firstNameEN = fullNameEN.substring(0, lastIndexFullNameEN);
            let lastNameEN = fullNameEN.substring(lastIndexFullNameEN + 1);

            console.log('Card Info: ', dataDecrypted);

            $(DOB_YEAR.current).prop('value', year);
            $(DOB_MONTH.current).prop('value', month);
            $(DOB_DAY.current).prop('value', day);
            INPUT_FIRSTNAME_TH.current.value = firstNameTH;
            INPUT_LASTNAME_TH.current.value = lastNameTH;
            INPUT_FIRSTNAME_EN.current.value = firstNameEN;
            INPUT_LASTNAME_EN.current.value = lastNameEN;

            setFormData({
                ...formData, 
                citizenid: formatCardID,
                firstname_th: firstNameTH,
                lastname_th: lastNameTH,
                firstname_en: firstNameEN,
                lastname_en: lastNameEN,
            })

            // setLockInputCardID(true);
        }
    }

    function registration()
    {
        return new Promise(async resolve => {
            let reqData = { "data" : "V6or36g33WFnEJXoVW5K3N8p4Kv6jVw0AYsSQ+w//H9RVO90OKyxskx3jJA/HbFaMWUkegUSozwJzz6TEXb9fVzyiJD0VkTfO6OEOsPiFb7DY3Wn9AHCIGTTNpiGOD1+79QIyvvBoquJY+/6gfbYfhX7IbvWEZu75O01x4EuGjld32EJ2TmjaTsex1m9aEFAVvr+jlLi6tM67Vpysx2Yty5GWdH5Y8RNVLd3hRkxvB+dy9WyTE3ZSPFXuCP/WkBA46bW7Drx1ovjnvXiI8yDSGnNrCtr/97YEPwUrpwcOjv+XR0w83yWneLYVqn0uS7xicHEfIB2FgWLTDUBSfEbDwtbmxy56dx031HcqpvfVsFgTf2LsWlcfmuHZBRw8iyk" }

            APIS_ACTION.Registration(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function getUserSignin()
    {
        let reqData = { "data" : "vAHaIZ3RroXQ4EXMR12c0pmazd1ZB1TP" }

        return new Promise(async resolve => {
            APIS_ACTION.GetUserSignin(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function verifyOTP(OTP)
    {
        let rawReq = { 
            "_otp":"1",
            "_refotp":"abc123456",
            "_refverify": "/6gfbYfhX7IbvWEZu75O01x4EuGjld32EJ2TmjaTsex1m9aEFAVvr+"
        }
        let reqData = { "data" : "be6CQZauMe4LCx3lJAa92ck+FKxd6C9vk0JrjFb11eYR7dYVId3Bcd5LMzKWqcpqr17P3wFat3ck9g6HZ6MDiuSDxkm4F+0n7SeS4MP7oPcwP7SlpiRuH7CPfKSc+EgkYkRmD/LgmUKf1r2PBD8eSUwH1LQAU0wYp1mBNZMozXBqGI1lkeRygkhOlMpRpPH7hRemk2QoWJFrMVY7WjwhTg==" }

        return new Promise(async resolve => {
            APIS_ACTION.VerifyOTP(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function sendOTPEmail()
    {
        let reqData = { "data" : "/phHvG+zA8q1QmstjjsWgA==" }

        return new Promise(async resolve => {
            APIS_ACTION.SendOTP_Email(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function sendOTPSMS()
    {
        let phoneNumber = '0958129601';
        let phoneEnc = EncryptedText(phoneNumber);
        let reqData = { "data" : phoneEnc } // = 1 (type number)

        return new Promise(async resolve => {
            APIS_ACTION.SendOTP_SMS(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve(res.data);
                }
            })
        })
    }

    function getJWTToken()
    {
        return new Promise(async resolve => {
            let reqData = {"UserRef": "/phHvG+zA8q1QmstjjsWgA==", "IPAddress": "123.123.123.123"}
            
            APIS_ACTION.JWT_Authen(reqData)
            .then(res => {
                console.log('Get JWT Token: ', res);
                if(!!res)
                {
                    resolve(res)
                }
            })
        })
    }

    function getProfile(jwtToken){
        let headers = {
            "Authorization": `Bearer ${jwtToken.Token}`,
            "authorizeRef": jwtToken.TokenRef,
            "userRef": "/phHvG+zA8q1QmstjjsWgA==" // this data = 1 (type number)
        };
        let reqData = {
            "data": "/phHvG+zA8q1QmstjjsWgA=="
        };

        return new Promise(async resolve => {
            APIS_ACTION.GetProfile(reqData, headers)
            .then(res => {
                console.log('Get Profile: ', res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function EditProfile(jwtToken){
        let headers = {
            "Authorization": `Bearer ${jwtToken.Token}`,
            "authorizeRef": jwtToken.TokenRef,
            "userRef": "/phHvG+zA8q1QmstjjsWgA==" // this data = 1 (type number)
        };
        let reqData = {
            "data" : "JAHY/jXbpgmdWSH+guPQZzE0IY/QDpZL9JggpZHxh8tGsb6iAtLeUFpmATkuRB0HVyWKi4qWth9CzA8Tl0fBmJlf8Fvxb+80zfKYuPuJDe34n8ZCzrpHkcT3sjymFVdj3sj2ppqokXgm+zp6ovE+2ZZUzu0QsPZB4AcHj+GJf58fkLxqn9czaRYNBWotm7yRIvdk2zTLnulW5D5anwBmWfXyYQdtscupoKYjmOu/ylBcN02Cy5qlLsJrds0bocWm8TtCbnfaYOt88UWVJb+HvNMwrirYYhxfDPmhCYGFfh3OfNdIK5AqgDkU411fHDg6N2G1cxJ/Qskf9dH6VMtkwvFOPBiOAFR21B9OkTt2Yhg="
        };

        return new Promise(async resolve => {
            APIS_ACTION.EditProfile(reqData, headers)
            .then(res => {
                console.log('Edit Profile: ', res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function signinPhone(){
        return new Promise(async resolve => {
            let reqData = { "data" : "/phHvG+zA8q1QmstjjsWgA==" }

            APIS_ACTION.Signin_Phone(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    resolve();
                }
            })
        })
    }

    function signinEmail()
    {
        return new Promise(async resolve => {
            let reqData = { "data" : "/phHvG+zA8q1QmstjjsWgA==" }
            
            APIS_ACTION.Signin_Email(reqData)
            .then(res => {
                console.log(res);
                if(!!res)
                {
                    resolve(res)
                }
            })
        })
    }

    function dropdownInit() {
        return new Promise(async resolve => {
            let monthNumber = new Date().getMonth()+1;
            let days = getDaysInMonth(monthNumber);
            let daysList = getDaysList(days);
            let yearList = getYearList();
            let currentAge = calculateAge(daysList[0], 1, yearList[0]);
    
            setDDdays(daysList);
            setDDyears(yearList);

            // Citizent ID (Input Init)
            let type_regis = DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS));
            console.log('type register: ', type_regis);
            if(type_regis === 'idcard')
            {
                setTypeRegis(true);
            }else
            {
                setTypeRegis(false);
            }

            resolve();
        })
    }

    function getDaysInMonth(monthId) {
        // Create a new Date object for the specified month
        const date = new Date(2023, monthId, 0);

        // Get the number of days in the month
        const daysInMonth = date.getDate();

        return daysInMonth;
    }
    const getDaysList = (days) => {
        let daysList = new Array();
        for (let i = 1; i <= days; i++) {
            daysList.push(i);

            if (Number(i) === days) {
                return daysList;
            }
        }
    };
    const getYearList = () => {
        let yearList = new Array();
        let year = new Date().getFullYear();
        let minYear = year - 100;

        for (let i = minYear; i <= year; i++) {
            yearList.push(i);

            if (Number(i) === year) {
                yearList = yearList.sort(function (a, b) {
                    return b - a;
                }); // ASC มากไปน้อย
                return yearList;
            }
        }
    };
    function calculateAge(day, month, year) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
        const currentDay = currentDate.getDate();

        let age = currentYear - year;

        // Check if the current date (month and day) is before the birthdate
        if (currentMonth < month || (currentMonth === month && currentDay < day)) {
            age--;
        }

        return age < 0 ? 0 : age; // Don't Return Value = 0
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let day = DOB_DAY.current.value;
        let month = DOB_MONTH.current.value;
        let year = DOB_YEAR.current.value;
    
        // let currentAge = calculateAge(day, month, year);
        // INPUT_AGE.current.value = currentAge;

        if(name === 'month')
        {
            let days = getDaysInMonth(Number(month));
            let daysList = getDaysList(days);
            console.log('Day List :', daysList);
            setDDdays(daysList);
        }
        console.log('Month: ', month);
    };

    const onSubmit = async(e) => {
        e.preventDefault();
        
        // Form Validation
        if(formValidation())
        {
            await getFormData()
            .then(() => {
                nextPage();
            })
        }
    };

    const checkUser = () => {
        return new Promise(((resolve, reject) => {
            let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, ''); 
            let enc_phone_number = EncryptedText(phone_number);
            let reqData = {data: enc_phone_number}

            // Check Phone
            APIS_ACTION.Signin_Phone(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess === false && res.ErrCode === 0)
                {
                    // Check Email
                    let email = String(INPUT_EMAIL.current.value);
                    if(!!email)
                    {
                        let reqDataEmail = {data: EncryptedText(email)}
    
                        APIS_ACTION.Signin_Email(reqDataEmail)
                        .then(res => {
                            if(res.IsSuccess === false && res.ErrCode === 0) 
                            {
                                resolve(); // ไม่มีในระบบ สามารถสมัครสมาชิกต่อได้
                            }else
                            {
                                reject();
                            }
                        })
                    }else
                    {
                        resolve();
                    }
                }else
                {
                    reject();
                }
            })
        }))
    }

    const getFormData = () => {
        return new Promise(async resolve => {
            let cardDetectedId = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD)) : null ;
            let cardid = !isForeign && !!cardDetectedId ? String(cardDetectedId.card_id).replace(/\D/g, '') : ""; // true = idcard | false = passport
            let back_idcard = !isForeign && !!cardDetectedId ? String(formData.back_idcard).replace(/[^a-zA-Z0-9]/g, '') : "";
            let passport = isForeign && !!cardDetectedId ? String(INPUT_PASSPORT_ID.current.value).replace(/[^a-zA-Z0-9]/g, '') : "";
            let first_name_th = String(INPUT_FIRSTNAME_TH.current.value);
            let last_name_th = String(INPUT_LASTNAME_TH.current.value);
            let first_name_en = String(INPUT_FIRSTNAME_EN.current.value);
            let last_name_en = String(INPUT_LASTNAME_EN.current.value);
            let dob = moment(String(`${DOB_DAY.current.value}-${DOB_MONTH.current.value}-${DOB_YEAR.current.value}`), 'DD-M-YYYY').format('DD-MM-YYYY');
            let gender = formData.gender;
            let marry = formData.marry;
            let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, '');
            let email = INPUT_EMAIL.current.value;

            console.log('Card ID: ', cardid);
            console.log('Back ID Card: ', back_idcard);
            console.log('Passport Number: ', passport);
            console.log('first name TH: ', first_name_th);
            console.log('last name TH: ', last_name_th);
            console.log('first name EN: ', first_name_en);
            console.log('last name EN: ', last_name_en);
            console.log('DOB: ', dob);
            console.log('Gender: ', gender);
            console.log('Marry: ', marry);
            console.log('Phone Number: ', phone_number);
            console.log('Email: ', email);

            let regis_info = {
                cardid,
                back_idcard,
                passport,
                first_name_th,
                last_name_th,
                first_name_en,
                last_name_en,
                dob,
                gender,
                marry,
                phone_number,
                email,
            }
            let enc_regis_info = EncryptedOBJ(regis_info);

            let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;             
            if(!!updateKycPayload)
            {
                let occForm = {
                    ...updateKycPayload,
                    ...regis_info
                }

                localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, EncryptedOBJ(occForm))

                resolve();
            }else
            {
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, enc_regis_info);
            }

            // เซท type otp เพื่อให้หน้า otp รู้ว่า otp มาจาก register หรือ login
            let type_otp = EncryptedText('kyc'); // register, kyc
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP, type_otp);

            resolve();
        })
    }
    const formValidation = () => {
        let card_id = !isForeign ? String(INPUT_CARD_ID.current.value).replace(/-/g, '') : "";
        let passport = isForeign ? String(INPUT_PASSPORT_ID.current.value) : "";
        // let backidcard = !isForeign ? String(formData.back_idcard).replace(/-/g, '') : "";

        let first_name_th = String(INPUT_FIRSTNAME_TH.current.value);
        let last_name_th = String(INPUT_LASTNAME_TH.current.value);
        let first_name_en = String(INPUT_FIRSTNAME_EN.current.value);
        let last_name_en = String(INPUT_LASTNAME_EN.current.value);

        let gender = formData.gender;
        let marry = formData.marry;
        // let age = Number(INPUT_AGE.current.value);
        let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, '');
        let email = INPUT_EMAIL.current.value;

        let errors = {};
        let formIsValid = true;

        if((!card_id || card_id.length < 13) && isForeign === false) // isForeign = true => ต่างชาติ | ต้องใช้ passport
        {
            // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
            errors["idcard"] = "*กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน";
            formIsValid = false;
        }
        // if((!backidcard || backidcard.length < 12) && isForeign === false)
        // {
        //     // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
        //     errors["back_idcard"] = "*กรุณากรอกเลขหลังบัตรประจำตัวประชาชนให้ครบถ้วน";
        //     formIsValid = false;
        // }

        if((!passport || !isValidPassportFormat(passport)) && isForeign === true)
        {
            // กรุณากรอกพาสปอร์ตให้ครบถ้วน
            errors["passport"] = "*กรุณากรอกพาสปอร์ตให้ครบถ้วน";
            formIsValid = false;
        }
        
        //? ปิดไว้้เพราะว่า ให้รองรับเคสผู้ใช้งานที่มาจาก channel อื่น (ผู้ใช้ที่มาจาก channel อื่น จะไม่มีข้อมูลนี้ และจะติด form validation จึงต้องเอา required ออก)
        // if(!first_name_th || first_name_th.length <= 0)
        // {
        //     // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
        //     errors["first_name_th"] = "*กรุณากรอก ชื่อ ภาษาไทยให้ครบถ้วน";
        //     formIsValid = false;
        // }else
        // {
        //     if(!containsThaiCharacters(first_name_th))
        //     {
        //         // กรุณากรอกชื่อภาษาไทย
        //         errors["first_name_th"] = "*กรุณากรอกชื่อภาษาไทย";
        //         formIsValid = false; 
        //     }
        // }
        // if(!last_name_th || last_name_th.length <= 0)
        // {
        //     // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
        //     errors["last_name_th"] = "*กรุณากรอก นามสกุล ภาษาไทยให้ครบถ้วน";
        //     formIsValid = false;
        // }else
        // {
        //     if(!containsThaiCharacters(last_name_th))
        //     {
        //         // กรุณากรอกชื่อภาษาไทย
        //         errors["last_name_th"] = "*กรุณากรอก นามสกุล ภาษาไทย";
        //         formIsValid = false; 
        //     }
        // }
        
        // if(!first_name_en || first_name_en.length <= 0)
        // {
        //     // กรุณากรอก ชื่อ นามสกุล ภาษาอังกฤษ ให้ครบถ้วน
        //     errors["first_name_en"] = "*กรุณากรอก ชื่อ ภาษาอังกฤษให้ครบถ้วน";
        //     formIsValid = false;
        // }else
        // {
        //     if(!containsEnglishCharacters(first_name_en))
        //     {
        //         // กรุณากรอกชื่อภาษาไทย
        //         errors["first_name_en"] = "*กรุณากรอกชื่อภาษาอังกฤษ";
        //         formIsValid = false; 
        //     }
        // }
        // if(!last_name_en || last_name_en.length <= 0)
        // {
        //     // กรุณากรอก ชื่อ นามสกุล ภาษาอังกฤษ ให้ครบถ้วน
        //     errors["last_name_en"] = "*กรุณากรอก นามสกุล ภาษาอังกฤษให้ครบถ้วน";
        //     formIsValid = false;
        // }else
        // {
        //     if(!containsEnglishCharacters(last_name_en))
        //     {
        //         // กรุณากรอกชื่อภาษาไทย
        //         errors["last_name_en"] = "*กรุณากรอกนามสกุลภาษาอังกฤษ";
        //         formIsValid = false; 
        //     }
        // }
        
        if(!gender || gender === '')
        {
            // กรุณาระบุเพศ
            errors["gender"] = "*กรุณาระบุเพศ";    
            formIsValid = false;
        }

        if(!marry || marry === '')
        {
            // กรุณาระบุเพศ
            errors["marry"] = "*กรุณาสถานภาพสมรส";    
            formIsValid = false;
        }
        
        if(!phone_number || phone_number.length < 10)  
        {
            // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
            errors["tel"] = "*กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน";    
            formIsValid = false;
        }

        // if(!email || email.length === 0)  
        // {
        //     // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
        //     errors["email"] = "*กรุณากรอกอีเมลให้ครบถ้วน";    
        //     formIsValid = false;
        // }
        
        if(!!email && email.length > 0)
        {
            // checking email
            if(!isValidEmail(email))
            {
               // กรุณากรอกอีเมลให้ถูกต้อง
               errors["email"] = "*กรุณากรอกอีเมลให้ถูกต้อง";    
               formIsValid = false; 
            }
        }

        setErrorMsg(errors);
        return formIsValid;
    }
    function isValidPassportFormat(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');
      
        // Check if the cleaned passport number matches the format
        const validFormat = /^[A-Z]{1,2}\d{6,7}$/.test(cleanedPassportNumber);
      
        return validFormat;
    }

    const nextPage = () => {
        let invalidCitizenID = localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_CITIZENID_INVALID);
        if(!!invalidCitizenID)
        {
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME); 
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA); 
            window.location.href = `${Base_API.pathWeb}/n-health/signup/otp` 
        }else
        {
            window.location.href = `${Base_API.pathWeb}/n-health/kyc/step-2`
        }
    };

    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const handleChangePassport = (e) => {
        let name = e.target.name;
        let value = String(e.target.value).replace(/[^a-zA-Z0-9]/g, '');
        let formatValue = formatPassportNumber(value);

        if(!!value && isValidPassportFormat(formatValue))
        {
            setErrorMsg({
                ...errorMsg, passport: ''
            }) 
        }else
        {
            setErrorMsg({
                ...errorMsg, passport: '*กรุณากรอกพาสปอร์ตให้ครบถ้วน'
            })
        }
        
        setFormData({ ...formData, passport: formatValue });
    }

    function formatPassportNumber(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');
      
        // Convert letters to uppercase
        const uppercasePassportNumber = cleanedPassportNumber.toUpperCase();

        // Split the cleaned passport number into parts: letters and numbers
        const letters = uppercasePassportNumber.match(/[a-zA-Z]+/);
        const numbers = uppercasePassportNumber.match(/\d+/);
      
        // Check if both letters and numbers parts are present
        if (letters && numbers) {
          // Create the formatted passport number
          const formattedPassportNumber = `(${letters[0]}) ${numbers[0]}`;
          return formattedPassportNumber;
        } else {
          // Return the original cleaned passport number if formatting is not possible
          return uppercasePassportNumber;
        }
      }

    const onlyInputNumber = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const numericValue = value.replace(/\D/g, '');
    
        if (name === "card_id") {
            const isNumber = /^[\d-]*$/.test(value);
            if (isNumber) {
                if (numericValue.length <= 13) {
                    let formatValue = formatNationalID(numericValue);
                    setFormData({ ...formData, citizenid: formatValue });
                }
            }
            
            // Handle Error
            if(!numericValue || numericValue.length < 13)
            {
                // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
                setErrorMsg({...errorMsg, idcard: "*กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน"});
            }else
            {
                setErrorMsg({...errorMsg, idcard: ""});
            }
        }
        if (name === "tel") {
            const isPhoneNumberValid = /^[\d()\s-]*$/.test(value);
            const cleanedValue = value.replace(/\D/g, '');
            if (isPhoneNumberValid) {
                if (cleanedValue.length === 10) {
                    let formatValue = formatThaiPhoneNumber(cleanedValue);
                    setFormData({ ...formData, phone: formatValue });
                } else {
                    setFormData({ ...formData, phone: cleanedValue });
                }
            }
            
            if(!cleanedValue || cleanedValue.length < 10)  
            {
                // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
                setErrorMsg({...errorMsg, tel: "*กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน"});
            }else
            {
                setErrorMsg({...errorMsg, tel: ""});
            }
        }
    }
    
    const formatThaiPhoneNumber = (value) => {
        const numericValue = value.replace(/\D/g, '');
        let formattedValue = numericValue;
    
        if (numericValue.length > 3) {
            formattedValue = numericValue.replace(/^(\d{3,3})(\d{0,3})(\d{0,4})$/, '($1) $2-$3');
        }
    
        return formattedValue;
    };
    
    const formatNationalID = (value) => {
        const numericValue = value.replace(/\D/g, '');
        const formattedValue = numericValue.replace(/^(\d{1,1})(\d{4,4})(\d{5,5})(\d{2,2})(\d{1,1})$/, '$1-$2-$3-$4-$5');
        return formattedValue;
    };

    function sanitizeInput(input) {
        // Replace '<' and '>' characters with their HTML entities
        const sanitized = input.replace(/</g, "").replace(/>/g, "");
        return sanitized;
    }

    const checkValidInput = (e) => {
        let name = e.target.name;
        let value = e.target.value

        if(name === "fname_th")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก ชื่อ ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, first_name_th: "*กรุณากรอก ชื่อ ภาษาไทยให้ครบถ้วน"})
                setFormData({...formData, firstname_th: ""})
            }else
            {
                if(!containsThaiCharacters(value))
                {
                    // กรุณากรอกชื่อภาษาไทย
                    setErrorMsg({...errorMsg, first_name_th: "*กรุณากรอก ชื่อ ภาษาไทย"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, first_name_th: ""})
                    setFormData({...formData, firstname_th: cleanValue})
                }
            }
        }
        if(name === "lname_th")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, last_name_th: "*กรุณากรอก นามสกุล ภาษาไทยให้ครบถ้วน"})
                setFormData({...formData, lastname_th: ""})
            }else
            {
                if(!containsThaiCharacters(value))
                {
                    // กรุณากรอก นามสกุล ภาษาไทย
                    setErrorMsg({...errorMsg, last_name_th: "*กรุณากรอก นามสกุล ภาษาไทย"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, last_name_th: ""})
                    setFormData({...formData, lastname_th: cleanValue})
                }
            }
        }
        if(name === "fname_en")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก ชื่อ ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, first_name_en: "*กรุณากรอก ชื่อ ภาษาอังกฤษให้ครบถ้วน"})
                setFormData({...formData, firstname_en: ""})
            }else
            {
                if(!containsEnglishCharacters(value))
                {
                    // กรุณากรอก ชื่อ ภาษาไทย
                    setErrorMsg({...errorMsg, first_name_en: "*กรุณากรอก ชื่อ ภาษาอังกฤษ"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, first_name_en: ""})
                    setFormData({...formData, firstname_en: cleanValue})
                }
            }
        }
        if(name === "lname_en")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, last_name_en: "*กรุณากรอก นามสกุล ภาษาอังกฤษให้ครบถ้วน"})
                setFormData({...formData, lastname_en: ""})
            }else
            {
                if(!containsEnglishCharacters(value))
                {
                    // กรุณากรอก นามสกุล ภาษาไทย
                    setErrorMsg({...errorMsg, last_name_en: "*กรุณากรอก นามสกุล ภาษาอังกฤษ"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, last_name_en: ""})
                    setFormData({...formData, lastname_en: cleanValue})
                }
            }
        }
        if(name === "gender")
        {
            setFormData({...formData, gender: value})
            if(!!value)
            {
                setErrorMsg({...errorMsg, gender: ""})
            }
        }
        if(name === "relation")
        {
            setFormData({...formData, marry: value})
            if(!!value)
            {
                setErrorMsg({...errorMsg, marry: ""})
            }
        }
        if(name === "email")
        {
            if(!!value && value.length <= 0)
            {
                setErrorMsg({...errorMsg, email: "*กรุณากรอกอีเมลให้ครบถ้วน"})
                setFormData({...formData, email: ""})
            }else
            {
                // checking email
                if(!isValidEmail(value))
                {
                   // กรุณากรอกอีเมลให้ถูกต้อง
                   let cleanValue = sanitizeInput(value);
                   setErrorMsg({...errorMsg, email: "*กรุณากรอกอีเมลให้ถูกต้อง"})
                   setFormData({...formData, email: cleanValue})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, email: ""})
                    setFormData({...formData, email: cleanValue})
                }
            }
        }    
    }

    const backCardIDChange = (e) => {
        let value = e.target.value;
        const alphanumericValue = String(value.replace(/[^a-zA-Z0-9]/g, '')).toUpperCase();
        if(alphanumericValue.length === 12)
        {
            let formatValue = formatBackCardID(alphanumericValue)
            setFormData({...formData, back_idcard: formatValue})
            setErrorMsg({...errorMsg, back_idcard: ""})
        }else
        {
            setFormData({...formData, back_idcard: alphanumericValue})
            setErrorMsg({...errorMsg, back_idcard: "*กรุณากรอกเลขหลังบัตรประจำตัวประชาชนให้ครบถ้วน"})
        }
    }

    function containsEnglishCharacters(input) {
        const englishPattern = /[A-Za-z]/; // English letters
        return englishPattern.test(input);
    }
    function containsThaiCharacters(input) {
        const thaiPattern = /[\u0E00-\u0E7F]/; // Thai Unicode range
        return thaiPattern.test(input);
    }
    const formatBackCardID = (value) => {
        const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
        const formattedValue = alphanumericValue.replace(/(.{3})(.{7})(.{2})/, '$1-$2-$3');
        return formattedValue;
    };

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
          <div className="swal-cfpm">
            <div className="top">
              <img onClick={handleCloseAlert} src="/images/icons/close-btn-2.png" />
            </div>
      
            <div className="mid">
              <h2 className="title">{title}</h2>
              <p className="desc">
                {body}
              </p>
            </div>
      
            <div className={`bottom`}>
              <button type="button" onClick={handleCloseAlert}>
                {button}
              </button>
            </div>
          </div>
        );
    
        MySwal.fire({
          html: alertConfirmElem,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
    
      };
    
    const handleCloseAlert = () => {
        MySwal.close();
    };

    const onSkip = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/step-2`;
    }

    return (
        <>
            <div className="kyc-step-1-con container-profile">
                <PageLoader /> 
                <SignIn_Navbar canClose={false} />
                <Breadcrumb_Step step={1} />

                <h3 className="header-text">
                    ข้อมูลทั่วไป
                </h3>

                <form action="#" onSubmit={onSubmit} className="form-wrap">
                    {!isForeign
                        ? 
                            <div className="form-group"  name="id-card">
                                <label htmlFor="id-card">เลขบัตรประชาชน / พาสปอร์ต</label>
                                <input
                                    ref={INPUT_CARD_ID} 
                                    type="text" id="id-card" 
                                    readOnly={lockInputCardID} 
                                    placeholder="กรอกเลขบัตรประชาชน" 
                                    value={formData.citizenid}
                                    // disabled
                                    maxLength={17}
                                    name="card_id"
                                    onChange={onlyInputNumber}
                                    disabled
                                />
                                <p className="input-error">
                                    {errorMsg["idcard"]}
                                </p>
                            </div>
                        :
                            <div className="form-group"  name="id-card">
                                <label htmlFor="id-card">เลขบัตรประชาชน / พาสปอร์ต</label>
                                <input
                                    ref={INPUT_PASSPORT_ID} 
                                    type="text" id="passport-id" 
                                    placeholder="กรอกพาสปอร์ต" 
                                    value={formData.passport}
                                    maxLength={15}
                                    name="passport_id"
                                    onChange={handleChangePassport}
                                />
                                <p className="input-error">
                                    {errorMsg["passport"]}
                                </p>
                            </div>
                    }
                    {/* {!isForeign &&
                        <div className="form-group" name="fname">
                            <label htmlFor="backcard_id">เลขหลังบัตรประชาชน<br/><span className="text-blue">ขึ้นต้นด้วยตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก</span></label>
                            <input
                                type="text"
                                id="backcard_id"
                                name="backcard_id"
                                placeholder="กรอกเลขหลังบัตรประชาชน"
                                onChange={backCardIDChange}
                                value={formData.back_idcard}
                                maxLength={12}
                            />
                            <p className="input-error">
                                {errorMsg["back_idcard"]}
                            </p>
                        </div>
                    } */}
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_th"
                            ref={INPUT_FIRSTNAME_TH}
                            value={formData.firstname_th}
                            placeholder="กรอกชื่อ (ภาษาไทย)"
                            onChange={checkValidInput}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["first_name_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">นามสกุล (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="lname_th"
                            ref={INPUT_LASTNAME_TH}
                            value={formData.lastname_th}
                            placeholder="กรอกนามสกุล (ภาษาไทย)"
                            onChange={checkValidInput}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["last_name_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_en"
                            ref={INPUT_FIRSTNAME_EN}
                            value={formData.firstname_en}
                            placeholder="กรอกชื่อ (ภาษาอังกฤษ)"
                            onChange={checkValidInput}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["first_name_en"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">นามสกุล (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="fname"
                            name="lname_en"
                            ref={INPUT_LASTNAME_EN}
                            value={formData.lastname_en}
                            placeholder="กรอกนามสกุล (ภาษาอังกฤษ)"
                            onChange={checkValidInput}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["last_name_en"]}
                        </p>
                    </div>

                    {/* <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ-นามสกุล (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_th"
                            ref={INPUT_FULLNAME_TH}
                            placeholder="กรอกชื่อ-นามสกุล (ภาษาไทย)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["fullname_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="lname">
                        <label htmlFor="lname">ชื่อ-นามสกุล (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="lname"
                            name="fname_en"
                            placeholder="กรอกชื่อ-นามสกุล (ภาษาอังกฤษ)"
                            ref={INPUT_FULLNAME_EN}
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["fullname_en"]}
                        </p>
                    </div> */}
                    <div className="form-group" name="dob">
                        <label htmlFor="#">วันเดือนปีเกิด (ค.ศ.)</label>
                        <div className="sub-form-group">
                            <div className="left">
                                <select defaultValue={1} id="select-day" name="dob" onChange={handleChange} ref={DOB_DAY} disabled>
                                    {ddDays.map((item) => (
                                        <option value={item} key={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                            <div className="mid">
                                <select
                                    defaultValue={1}
                                    name="month"
                                    onChange={handleChange}
                                    id="select-month"
                                    ref={DOB_MONTH}
                                    disabled
                                >
                                    {ddMonth.map((item) => (
                                        <option value={item.id} key={item.id}>
                                            {item.nameTH}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                            <div className="right">
                                <select defaultValue={1} ref={DOB_YEAR} id="select-year" name="dob" onChange={handleChange}                             disabled>
                                    {ddYears.map((item) => (
                                        <option value={item} key={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                        </div>
                        <p></p>
                    </div>

                    <div className="form-group" name="gender2">
                        <label>เพศ</label> 
                        <div className="group-gdbtn">
                            <input ref={RADIO_FEMALE} onChange={checkValidInput} type="radio" name="gender" value="F" id="female" disabled />
                            <label htmlFor="female">หญิง</label>
                            <input ref={RADIO_MALE} onChange={checkValidInput} type="radio" name="gender" value="M" id="male" disabled />
                            <label htmlFor="male">ชาย</label>
                        </div>
                        <p className="input-error">
                           {errorMsg["gender"]}
                        </p>
                    </div>
                    <div className="form-group" name="relation">
                        <label>สถานะ</label> 
                        <div className="group-gdbtn">
                            <input ref={RADIO_SINGLE} onChange={checkValidInput} type="radio" value="S" name="relation" id="single" />
                            <label htmlFor="single">โสด</label>
                            <input ref={RADIO_MARRIED} onChange={checkValidInput} type="radio" value="M" name="relation" id="married" />
                            <label htmlFor="married">สมรส</label>
                        </div>
                        <p className="input-error">
                           {errorMsg["marry"]}
                        </p>
                    </div>


                    {/* <div className="form-group" name="gender-age">
                        <div className="left">
                            <label htmlFor="gender">เพศ</label>
                            <span>
                                <select 
                                    defaultValue={"default"}
                                    ref={DD_GENDER}
                                    // onFocus={() => $('#slgender-default').remove()}
                                    name="gender"
                                    onChange={checkValidInput}
                                >
                                    <optgroup label="ระบุเพศ">
                                        <option id="slgender-default" disabled selected value="default">-</option>
                                        {ddGender.map((item) => (
                                            <option value={item.id} key={item.id}>
                                                {item.nameTH}
                                            </option>
                                        ))}
                                    </optgroup>
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </span>
                        </div>
                        <div className="right">
                            <label htmlFor="age">อายุ</label>
                            <input type="number" ref={INPUT_AGE} defaultValue={0} disabled />
                        </div>
                        <p className="input-error">
                            {errorMsg["gender"]}
                        </p>
                        <p className="input-error">
                            {errorMsg["age"]}
                        </p>
                    </div> */}

                    <div className="form-group" name="phone">
                        <label>เบอร์โทรศัพท์</label>
                        <input
                            type="tel"
                            ref={INPUT_PHONE_NUMBER}
                            maxLength={10}
                            placeholder="กรอกเบอร์โทรศัพท์"
                            value={formData.phone}
                            name="tel"
                            onChange={onlyInputNumber}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["tel"]}
                        </p>
                    </div>
                    <div className="form-group" name="phone">
                        <label>อีเมล (ถ้ามี)</label>
                        <input 
                            ref={INPUT_EMAIL} 
                            type="email" 
                            placeholder="กรอกอีเมล (ถ้ามี)" 
                            name="email"
                            value={formData.email}
                            onChange={checkValidInput}
                            disabled
                        />
                        <p className="input-error">
                            {errorMsg["email"]}
                        </p>
                    </div>

                    {/* <button 
                        className={`btn-save`} type="button" 
                        // onClick={onSubmit}
                        onClick={onSkip}
                    >
                        บันทึกข้อมูล
                    </button> */}
                    <button 
                        className={`btn-submit`} type="submit" 
                        onClick={onSubmit}
                        // onClick={onSkip}
                    >
                        อัพเดต KYC
                    </button>
                </form>
                {/* <PrivacyPolicy /> */}
            </div>
        </>
    );
}
